import LayoutActividad from "../../../components/LayoutActividad";
import Juana from "../../../images/modulo14/juana.png";
import Benito from "../../../images/modulo14/benito.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad3Actividad4.mp3";

const Actividad8 = () => {
  const infoUnidad = modulo14.content[2];
  const infoAct = modulo14.content[2].activities[4];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo14.content[2].name}: ${modulo14.content[2].activities[5].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[5].path}`,
    titlePrev: `${modulo14.content[2].name}: ${modulo14.content[2].activities[3].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[3].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>Lee las historias que nos cuentan Benito y Juana. </li>
      </ul>

      <div className="row align-items-center">
        <div className="col-md-6">
          <p className="fs-5">
            Mis antepasados llegaron al Perú desde África. En mi pueblo de
            Chincha, en el departamento de Ica, tenemos una forma especial de
            hablar. Por ejemplo, muchos decimos “Bueno día” en vez de “Buenos
            días”. Recuerdo que en una entrevista de trabajo en una clínica me
            dijeron que tenía que mejorar mi forma de hablar si quería el
            trabajo.
          </p>
        </div>
        <div className="col-md-6">
          <img src={Benito} className="img-fluid" alt="Benito" />
        </div>
      </div>
      <div className="row align-items-center mt-4">
        <div className="col-md-6">
          <img src={Juana} className="img-fluid" alt="Benito" />
        </div>
        <div className="col-md-6">
          <p className="fs-5">
            Recuerdo mucho a mi abuelita que había nacido en China. Ella hablaba
            un castellano que tenía influencia del chino. En vez de decir
            “perro” decía “pelo”. A veces la gente que entraba a su bodega a
            comprar algo se reía de ella.
          </p>
        </div>
      </div>

      <ul className="mt-5">
        <li>
          Ahora, responde estas preguntas. Utiliza en tus respuestas algunas de
          estas palabras.{" "}
        </li>
      </ul>
      <div className="row align-items-center my-5 px-4">
        <div className="col-lg-10 col-12">
          <div className="border border-2 rounded p-4 mb-5">
            <div className="d-flex justify-content-around align-items-center">
              <div className="px-2">prestigio</div>
              <div className="px-2">valor</div>
              <div className="px-2">respeto</div>
            </div>
          </div>
          <p>
            ¿Por qué crees que le pidieron a Benito que cambiara su forma de
            hablar?
          </p>
          <textarea className="form-control w-100 mb-4" rows="4" />
          <p>
            ¿Por qué se reía la gente de la forma de hablar de la abuela de
            Juana?
          </p>
          <textarea className="form-control w-100" rows="4" />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Lee las historias que nos cuentan Benito
            y Juana. Pida al niño o a la niña que lean las historias de Benito y
            Juana en voz alta.
          </li>
          <li>
            Pregunte qué tienen en común ambos casos. La idea es que se den
            cuenta de que tanto Benito como la abuela de Juana tuvieron
            problemas por su forma de hablar el castellano. Lea la siguiente
            indicación: Ahora, responde estas preguntas. Utiliza en tus
            respuestas algunas de estas palabras: prestigio – valor – respeto.
            Antes de realizar la actividad, pregunte por el significado de las
            palabras. Mencione que los significados de estas tres palabras son
            muy parecidos porque implican la importancia, autoridad o
            consideración que se le da a algo o alguien. Pida a un niño o niña
            que lea las dos preguntas: ¿Por qué crees que le pidieron a Benito
            que cambiara su forma de hablar? ¿Por qué se reía la gente de la
            forma de hablar de la abuela de Juana? Dé un tiempo para que
            trabajen. Retome y comente sus respuestas. La idea es que se den
            cuenta de que algunas personas –como el que entrevistó en la clínica
            a Benito o las personas que compraban en la bodega de la abuela de
            Juana– consideran que el castellano debe hablarse de una sola forma
            y que esa forma de hablar es la que tiene prestigio. Por ello,
            muchas veces, no se valoran las otras variedades de castellano.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
